import { Dispatch } from '@reduxjs/toolkit'
import { PageQuery } from 'utils/api'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { LeadsApiClient } from 'utils/api/leadsApi'

import { clientsSlice } from './clients.slice'

export const fetchTaxAvailabilityStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getTaxAvailabilityStatus()
      dispatch(clientsSlice.actions.setClientTaxAvailabilityStatuses(response))
    } catch (e) {
      console.error('Cannot get client tax availability status', e)
    }
  }
}

export const fetchAMLCategoriesTypes = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.fetchAMLRiskCategories()
      dispatch(clientsSlice.actions.setClientAMLCategories(response))
    } catch (e) {
      console.error('Cannot get client AML Risk Categories status', e)
    }
  }
}

export const fetchAMLAdjustmentReasons = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.fetchAMLAdjustmentReasons()
      dispatch(clientsSlice.actions.setClientAMLAdjustmentReasons(response))
    } catch (e) {
      console.error('Cannot get client AML Risk Categories status', e)
    }
  }
}

export const fetchOwnershipStructuresAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getOwnershipStructures()
      dispatch(clientsSlice.actions.setClientCorporateOwnershipStructuresTypes(response))
    } catch (e) {
      console.error('Cannot get client tax availability status', e)
    }
  }
}

export const fetchTickmillProductsAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getTickmillProducts()
      dispatch(clientsSlice.actions.setClientTickmillProducts(response))
    } catch (e) {
      console.error('Cannot get client tickmill products', e)
    }
  }
}

export const fetchClientWorldCheckStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientWorldCheckStatus()
      dispatch(clientsSlice.actions.setClientWorldCheckStatus(response))
    } catch (e) {
      console.error('Cannot get client world check status', e)
    }
  }
}

export const fetchClientLeverageTypeAction = (
  clientId: string,
  clientsApiClient: ClientsApiClient,
  query?: PageQuery
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientLeverageType(clientId, query)
      dispatch(clientsSlice.actions.setClientLeverageType(response))
    } catch (e) {
      console.error('Cannot get client leverage type.', e)
    }
  }
}

export const fetchClientTruliooEidStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientTruliooEidStatus()
      dispatch(clientsSlice.actions.setClientTruliooEidStatus(response))
    } catch (e) {
      console.error('Cannot get client trulioo eid statuses', e)
    }
  }
}

export const fetchClientTruliooWatchlistStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientTruliooWatchlistStatus()
      dispatch(clientsSlice.actions.setClientTruliooWatchlistStatus(response))
    } catch (e) {
      console.error('Cannot get client trulioo watchlist statuses', e)
    }
  }
}

export const fetchClientSalesStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientSalesStatus()
      dispatch(clientsSlice.actions.setClientSalesStatus(response))
    } catch (e) {
      console.error('Cannot get client sales statuses', e)
    }
  }
}

export const fetchLeadSalesStatusAction = (apiClient: LeadsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await apiClient.getLeadSalesStatus()
      dispatch(clientsSlice.actions.setLeadSalesStatus(response))
    } catch (e) {
      console.error('Cannot get lead sales statuses', e)
    }
  }
}

export const fetchClientTruliooDocVStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientTruliooDocVStatus()
      dispatch(clientsSlice.actions.setClientTruliooDocVStatus(response))
    } catch (e) {
      console.error('Cannot get client trulioo docv statuses', e)
    }
  }
}

export const fetchClientTypesAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientTypes()
      dispatch(clientsSlice.actions.setClientTypes(response))
    } catch (e) {
      console.error('Cannot get client types', e)
    }
  }
}

export const fetchClientCompanyTypesAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientCompanyTypes()
      dispatch(clientsSlice.actions.setClientCompanyTypes(response))
    } catch (e) {
      console.error('Cannot get client company types', e)
    }
  }
}

export const fetchClientStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const statuses = await clientsApiClient.getClientStatus()
      dispatch(clientsSlice.actions.setClientStatus(statuses))
    } catch (e) {
      console.error('Cannot get client types', e)
    }
  }
}

export const fetchClientReasonStatusAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getStatusReason()
      dispatch(clientsSlice.actions.setClientStatusReason(response))
    } catch (e) {
      console.error('Cannot get client status reasons', e)
    }
  }
}

export const fetchClientGenderTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientGenderType()
      dispatch(clientsSlice.actions.setClientGender(response))
    } catch (e) {
      console.error('Cannot get client gender', e)
    }
  }
}

export const fetchClientNciTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientNciType()
      dispatch(clientsSlice.actions.setClientNciType(response))
    } catch (e) {
      console.error('Cannot get client nci types', e)
    }
  }
}

export const fetchClientEducationAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientEducationLevelType()
      dispatch(clientsSlice.actions.setClientEducation(response))
    } catch (e) {
      console.error('Cannot get client nci types', e)
    }
  }
}

export const fetchClientDocumentTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientDocumentType()
      dispatch(clientsSlice.actions.setClientDocumentType(response))
    } catch (e) {
      console.error('Cannot get client doc types', e)
    }
  }
}

export const fetchClientOnboardingFlowTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientOnboardingFlowType()
      dispatch(clientsSlice.actions.setOnboardingFlowType(response))
    } catch (e) {
      console.error('Cannot get client doc types', e)
    }
  }
}

export const fetchClientBusinessNatureTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientBusinessNatureType()
      dispatch(clientsSlice.actions.setClientBusinessNature(response))
    } catch (e) {
      console.error('Cannot get client business.', e)
    }
  }
}

export const fetchClientLanguagesAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientLanguages()
      dispatch(clientsSlice.actions.setClientLanguages(response))
    } catch (e) {
      console.error('Cannot get client languages.', e)
    }
  }
}

export const fetchClientClassificationTypeAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientClassificationType()
      dispatch(clientsSlice.actions.setClientClassificationType(response))
    } catch (e) {
      console.error('Cannot get client classification type.', e)
    }
  }
}

export const fetchClientMarketDataClassificationTypeAction = (
  clientsApiClient: ClientsApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientMarketDataClassificationType()
      dispatch(clientsSlice.actions.setClientMarketDataClassificationType(response))
    } catch (e) {
      console.error('Cannot get client classification type.', e)
    }
  }
}

export const fetchPossibleClientDuplicate =
  (clientId: string, clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientPossibleDuplicate(clientId)
      dispatch(clientsSlice.actions.setClientPossibleDuplicate(response))
    } catch (e) {
      console.error('Error during get client duplicated', e)
    }
  }

export const fetchPossibleClientRelation =
  (clientId: string, clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientRelations(clientId)
      dispatch(clientsSlice.actions.setClientPossibleRelations(response))
    } catch (e) {
      console.error('Error during get client relations', e)
    }
  }

export const fetchClientRestrictionAction =
  (clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getClientRestrictions()
      dispatch(clientsSlice.actions.setClientRestrictions(response))
    } catch (e) {
      console.error('Error during get client restrictions', e)
    }
  }

export const fetchLegalBasesTypesAction =
  (clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getLegalBasesTypes()
      dispatch(clientsSlice.actions.setClientLegalBasesTypes(response))
    } catch (error) {
      console.error('Error during get client restrictions', error)
    }
  }

export const fetchClientAppropriatenessTestCategoriesAction =
  (clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getAppropriatenessTestCategories()
      dispatch(clientsSlice.actions.setClientAppropriatenessTestCategories(response))
    } catch (error) {
      console.error('Error during get client restrictions', error)
    }
  }

export const fetchClientAppropriatenessTestSubCategoriesAction =
  (clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getAppropriatenessTestSubCategories()
      dispatch(clientsSlice.actions.setClientAppropriatenessTestSubCategories(response))
    } catch (error) {
      console.error('Error during get client restrictions', error)
    }
  }

export const fetchComplianceVulnerabilityGroupsAction =
  (clientsApiClient: ClientsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getComplianceVulnerabilityGroups()
      dispatch(clientsSlice.actions.setComplianceVulnerabilityGroups(response))
    } catch (error) {
      console.error('Error during get client restrictions', error)
    }
  }

export const fetchClientKYCProvidersAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await clientsApiClient.getKYCProviders()
      dispatch(clientsSlice.actions.setClientKYCProviders(response))
    } catch (e) {
      console.error('Cannot get client KYC providers', e)
    }
  }
}
